import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, EMPTY, map, switchMap } from 'rxjs';
import { TimelineSubscriptionsApi } from '../../api/timeline-subscriptions.api';
import { TimelineSubscriptionsActions } from './timeline-subscriptions.action';

@Injectable()
export class TimelineSubscriptionsEffects {
  getSubscriptions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TimelineSubscriptionsActions.getSubscriptions),
      switchMap(() => {
        return this.timelineSubscriptionsApi.getTimelineSubscriptionInformation().pipe(
          map((body) => ({type: '[Subscriptions] Subscriptions loaded', body})),
          catchError(() => {
            console.error('Unable to load subscriptions');
            return EMPTY;
          })
        );
      })
    );
  }, {
    dispatch: true
  });


  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly timelineSubscriptionsApi: TimelineSubscriptionsApi
    ) {}
}
